import React from "react";
import {Layout, Row, Col, Switch, message} from "antd";
import TableWrapper from "../elements/TableWrapper";
import MiCompAPI from "../../util/api";


const { Content } = Layout;
class ManageTriggers extends React.Component {
    
    settings_columns = [
        {
        title: 'Event Name',
        dataIndex: "eventName",
        // sorter: (a, b) => a.eventName.localeCompare(b.eventName),
        // sortDirections: ["descend", "ascend"],
      },
      
      {
              title: "Status",
              dataIndex: "status",
              width: 180,
              render: (text, record) => {
                return (
                  <div style={{ display: 'flex' }}>
       <Switch defaultChecked={record["status"]}  style={{ marginRight: '10px' }} onChange={() => this.ChangeStatusById(record,text)}/>
                  </div>
                );
              },
        },
        
    ];
    constructor(props) {
        super(props);
        this.state = {
            Triggers:[],
            eventTriggers:null
        };
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }

    ChangeStatusById = (data) => {   
        data.status=!data.status;
        this.api.invoke("UpsertEventTriggers", "post", 
        (data, success) => {
          if (success) {
            if (data.statusCode === 200) {
              message.destroy();
              message.success(data.statusMessage, 3);
            }
            else {
              message.destroy();
              message.error(data.statusMessage, 3);
            }
            this.GetEventTriggers();
          }
        },data);
      }
    
    componentDidMount = () => {
        this.GetEventTriggers();

    }
GetEventTriggers() {
       this.setState({ loadSettings: true });
        this.api.invoke("GetEventTriggers", "get",  (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                        this.setState({ Triggers: data.data, loadSettings: false });
                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            }
        );
    }
  
    UpsertEventTriggers(val) {        
        this.api.invoke(
            "UpsertEventTriggers",
            "post",
            (data, success) => {
                if (success) {
                    if (data.statusCode === 200) {
                       this.GetEventTriggers();

                    } else {
                        message.destroy();
                        message.error(data.statusMessage, 3);
                    }
                }
            },val
        );
    }


render(){
return(
    <Content>
                <div className="mi_main_div">
                    <div className="mi_main" style={{marginTop:"10px"}} >                     
                        <Row>
                        <Col md={4} sm={24}></Col>
                            <Col  md={16} sm={24}>
                            <p className='mi_title'>Manage Triggers</p>
                           <TableWrapper
                             rowkey="id" 
                              columns={this.settings_columns} 
                              data={this.state.loadSettings ? null : this.state.Triggers} 
                              loading={this.state.loadSettings}
                               /> 
                            </Col>
                            <Col md={4} sm={24}></Col>
                        </Row>
                    </div>
                </div>
            </Content>
        );
}
}
export default ManageTriggers;